import axios from 'axios';

export const REQUEST_DATA = 'REQUEST_DATA';
export const REQUEST_FAILURE = 'REQUEST_FAILURE';
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS';

function requestData() {
    return {
        type: REQUEST_DATA,
    };
}

function requestFailure(error) {
    return {
        type: REQUEST_FAILURE,
        error,
    };
}

function requestSuccess(data) {
    return {
        type: REQUEST_SUCCESS,
        data,
    };
}

export function fetchData(requestedDate) {
    return (dispatch) => {
        dispatch(requestData());
        return axios.get(`/non-runners/data/${requestedDate}.json`, { credentials: 'include' })
            .then(({ data }) => dispatch(requestSuccess(data)))
            .catch(e => dispatch(requestFailure(e)));
    };
}



// WEBPACK FOOTER //
// ./src/js/nonRunners/nonRunners.actions.js